const Footer = () => {
    return (
        <footer className="footer">
            <p>&copy; 2026 <a href="https://zetchain.com">ZetChain</a>. All rights reserved.</p>
        </footer>
    );
}

export default Footer;